// extracted by mini-css-extract-plugin
module.exports = {"title":"SnoozeIndividualListing_title__b1zSb","img":"SnoozeIndividualListing_img__SENRI"};